import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Services";
import getToken from "app/api/getToken";
import { IService } from "app/api/types/Services";

export const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAIL = "GET_SERVICES_FAIL";

export const getServices = () => (dispatch: any): any => {
  dispatch({ type: GET_SERVICES_REQUEST });

  const token = getToken();

  return api
    .getServices(token)
    .then((response: AxiosResponse) => {
      const serviceList: IService[] = get(response, "data", {});
      dispatch({ type: GET_SERVICES_SUCCESS, payload: serviceList });

      return serviceList;
    })
    .catch(err => {
      dispatch({
        type: GET_SERVICES_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
